import { environment } from "../environments/environment";

import { isDevEnv, isCanaryTestEnv } from "./getEnvironment";

export const createServiceBaseUrl = (region?: string | null) => {
  if (!region && (isDevEnv() || isCanaryTestEnv())) {
    return `https://${environment.domainName}`;
  } else if (!region) {
    return `https://${environment.domainName}.com`;
  } else {
    return `https://${region.trim()}-${environment.domainName}.com`;
  }
};
